//智慧安全用电
export default [{
	//监测设备
	path: '/jzsb',
	name: 'jzsb',
	component: () => import('@/page/system/zhanyd/jzsb.vue')
}]